export default __webpack_public_path__ + "82b6b93bd21c3407f53a640c87fdf482.glb";